module.exports = __webpack_public_path__ + "media/site/images/app-preview/dashboard@2x-5af1f45c13a23369defe131b446bc669.png";